import { User } from "firebase/auth";
import { auth as firebaseAuth } from "./firebase";

export type Auth = {
  getUser: () => Promise<User | null>;
};

export const auth: Auth = {
  getUser: () =>
    new Promise<User | null>((resolve, reject) => {
      firebaseAuth.onAuthStateChanged(
        (user) => {
          if (user) {
            resolve(user);
          } else {
            resolve(null);
          }
        },
        (error) => {
          reject(error);
        },
      );
    }),
};
